import { Plaque } from "./Plaque";

/**
 * Wall-mounted roadmap plaque. Sister board to RulesBoard.
 *
 * Source: docs/koth-pumpfun-design.md § Roadmap. If the roadmap shifts,
 * update both this constant AND the doc — the plaque is the player-facing
 * surface, the doc is the source of truth for the team.
 */

interface RoadmapBoardProps {
  position: [number, number, number];
  rotation?: [number, number, number];
}

const ROADMAP_LINES: string[] = [
  "SHIPPED",
  "• On-chain Last-Touch rounds.",
  "• Pot funded by player touch fees.",
  "• Per-season leaderboards & all-time kings.",
  "• Rapid-fire session keys (no popup spam).",
  "• Spectator + voice chat in the throne hall.",
  "• Keeper daemon auto-settles expired rounds",
  "  AND auto-sweeps vault → pot every 60s.",
  "• Token buyback engine (skim → Jupiter →",
  "  token), per-launch, off by default.",
  "• Multi-launch ops surface — per-launch",
  "  Season, vault, keeper, theme, funnel.",
  "",
  "NEXT",
  "• Tournaments + scheduled mega-rounds.",
  "• Mobile-first HUD pass.",
  "",
  "LATER",
  "• Cosmetic NFTs unlocked by king streaks.",
  "• Public REST API for stats & embed widgets.",
];

export function RoadmapBoard({ position, rotation }: RoadmapBoardProps): JSX.Element {
  return (
    <Plaque
      position={position}
      rotation={rotation}
      width={4.4}
      height={5.0}
      backerColor="#0f1a2a"
      title="ROADMAP"
      titleColor="#7fc4ff"
      titleSize={0.28}
      lines={ROADMAP_LINES}
      bodyColor="#e8e8ef"
      bodySize={0.16}
      lineSpacing={1.18}
      align="left"
    />
  );
}
